import { render, staticRenderFns } from "./RequisitesSendModal.vue?vue&type=template&id=308a22b5"
import script from "./RequisitesSendModal.vue?vue&type=script&lang=js"
export * from "./RequisitesSendModal.vue?vue&type=script&lang=js"
import style0 from "./RequisitesSendModal.vue?vue&type=style&index=0&id=308a22b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports